type ExtendMeetingErrorFeedback = {
  content: string;
  canRebook?: boolean;
};

// 与 h5-client/recommend/MeetingExtendButton/meetingExtendAction 保持一致。
const EXTEND_MEETING_ERROR_FEEDBACK: Record<number, ExtendMeetingErrorFeedback> = {
  400403015: { content: '该会议已不存在，无法延长。请返回日程查看最新安排。' },
  400403053: { content: '当前会议不在进行中，无法延长。请刷新后查看最新会议状态。' },
  4001000: {
    content: '本次延长未增加会议时长，请刷新后重试，或重新预约会议。',
    canRebook: true
  },
  400403052: {
    content: '会议室在延长时段已有其他预约，无法延长。是否重新预约会议？',
    canRebook: true
  },
  400403002: {
    content: '延长时段与其他会议预约冲突，本次延长未成功。是否重新预约会议？',
    canRebook: true
  },
  400416026: { content: '暂时无法更新会议室预约，请稍后重试。' },
  400416024: { content: '会议日程更新失败，请刷新日程确认会议时间后再试。' }
};

const LEGACY_ERROR_MESSAGES = [
  { message: 'can not find the meeting through id:', code: 400403015 },
  { message: 'only progressing meeting can be extended', code: 400403053 },
  { message: '非进行中会议不可延长', code: 400403053 },
  { message: 'newEndTime must be after current endTime', code: 4001000 },
  { message: 'Room has conflicting bookings during the extended period', code: 400403052 },
  { message: 'Time conflicts with others', code: 400403002 }
];

const asErrorData = (value: unknown): Record<string, unknown> =>
  value !== null && typeof value === 'object' ? value as Record<string, unknown> : {};

const getErrorData = (error: unknown) => {
  const outer = asErrorData(error);
  const candidates = [outer, asErrorData(outer.data), asErrorData(asErrorData(outer.response).data)];
  // 业务结果自己的 code 优先，不被 data 中的冲突详情或下游错误覆盖。
  return candidates.find((data) => typeof data.code === 'number' || (typeof data.code === 'string' && /^\d+$/.test(data.code))) ||
    candidates.find((data) => typeof data.message === 'string') || {};
};

export const getExtendMeetingErrorFeedback = (error: unknown): ExtendMeetingErrorFeedback => {
  const data = getErrorData(error);
  const feedback = EXTEND_MEETING_ERROR_FEEDBACK[Number(data.code)];
  if (feedback) return feedback;
  const message = typeof data.message === 'string' ? data.message : '';
  const legacyError = LEGACY_ERROR_MESSAGES.find((item) => message.includes(item.message));
  return legacyError ? EXTEND_MEETING_ERROR_FEEDBACK[legacyError.code] : { content: '暂时无法延长会议，请稍后重试。' };
};
